export default {
	initializingStoreError: "An error occurred while preparing the page: {message}. Please refresh the page and try again.",
	fetchTeamError: "An error occurred while fetching team information: {message}. Pleas refresh the page and try again.",

	//
	// recent decisions
	//
	filterDaysLabel: "Last {days} days",
	fetchRecentDecisionsError: "An error occurred while fetching recent decisions: {message}.",

	//
	// team health
	//
	fetchTeamHealthSurveyError: "An error occurred while fetching the team health survey: {message}.",
	TeamHealth_UbiquitousTrust_Title: "Trust & Safety",
	TeamHealth_ProductiveConflict_Title: "Productive Conflict",
	TeamHealth_CommitmentToTeam_Title: "Team Commitment",
	TeamHealth_ActiveAccountability_Title: "Active Accountability",
	TeamHealth_TeamGoalFocus_Title: "Achieving Goals",
	TeamHealth_PositiveImpact_Title: "Positive Impact",
	TeamHealth_PurposeMeaning_Title: "Purpose & Meaning",

	//
	// team meetings
	//
	fetchTeamMeetingsError: "An error occurred while fetching team meetings: {message}.",

	//
	// team goals
	//
	fetchGoalsError: "An error occurred while fetching team goals: {message}.",
};



// WEBPACK FOOTER //
// ./src/lang/en/teamOverviewStore.js